/**
 * The pieces every /pipeline-facility screen draws the same way.
 *
 * IMPORTED, not copied: the register, chips, badge, panel, field and input are
 * the NDT screens' (which import the downhole ones), so the verticals stay one
 * shape. Nothing in those files is edited by this vertical.
 */
export {
  NdtBadge as PfBadge,
  NdtChip as PfChip,
  NdtChipRow as PfChipRow,
  NdtDialog as PfDialog,
  NdtEmpty as PfEmpty,
  NdtField as PfField,
  NdtFormError as PfFormError,
  NdtLoading as PfLoading,
  NdtPanel as PfPanel,
  NdtRegister as PfRegister,
  NdtSpec as PfSpec,
  NDT_INPUT as PF_INPUT,
  NDT_PRIMARY as PF_PRIMARY,
  NDT_SECONDARY as PF_SECONDARY,
  isNotFound,
  type NdtColumn as PfColumn,
} from '../ndt-inspection/NdtBits';

export const PF_EYEBROW = 'Pipeline & facility';

export { NDT_DATE_INPUT as PF_DATE_INPUT } from '../ndt-inspection/NdtBits';
